import styled from 'styled-components';

export const TagEditorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: ${(props) => props.theme.colors.primaryLight || '#EEF2FF'};
  color: ${(props) => props.theme.colors.primary || '#4F46E5'};
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

export const TagText = styled.span`
  line-height: 1;
`;

export const TagRemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;

export const AddTagButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: 1px dashed ${(props) => props.theme.colors.border || '#D1D5DB'};
  background: transparent;
  color: ${(props) => props.theme.colors.textSecondary || '#6B7280'};
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.colors.primary || '#4F46E5'};
    color: ${(props) => props.theme.colors.primary || '#4F46E5'};
    background: ${(props) => props.theme.colors.primaryLight || '#EEF2FF'};
  }
`;

export const TagInput = styled.input`
  padding: 4px 8px;
  border: 1px solid ${(props) => props.theme.colors.primary || '#4F46E5'};
  background: ${(props) => props.theme.colors.background || '#FFFFFF'};
  color: ${(props) => props.theme.colors.text || '#1F2937'};
  border-radius: 12px;
  font-size: 12px;
  outline: none;
  min-width: 100px;

  &::placeholder {
    color: ${(props) => props.theme.colors.textSecondary || '#9CA3AF'};
  }
`;

